import { render, staticRenderFns } from "./UniqModal.vue?vue&type=template&id=31c7ef80&scoped=true"
import script from "./UniqModal.vue?vue&type=script&lang=js"
export * from "./UniqModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c7ef80",
  null
  
)

export default component.exports